import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import _ from 'lodash';

function RequiresRole(props) {
  const {
    authentication: { isAuthenticated, sessionUser },
    children,
    requiredRoles,
    inverse,
  } = props;
  if (!children) return <></>;

  let requirements = requiredRoles;
  if (_.isString(requiredRoles)) requirements = [requiredRoles];
  let show =
    isAuthenticated &&
    (_.isEmpty(requirements) ||
      _.some(requirements, x => _.includes(sessionUser.roles, x)));

  if (inverse) show = !show;
  if (show) {
    return children;
  }
  return <></>;
}

RequiresRole.propTypes = {
  authentication: PropTypes.object.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.array,
    PropTypes.bool,
  ]),
  requiredRoles: PropTypes.oneOfType([PropTypes.string, PropTypes.array])
    .isRequired,
};

RequiresRole.defaultProps = {
  children: [],
};

function mapStateToProps(state) {
  const { authentication } = state;
  return { authentication };
}

export default connect(mapStateToProps)(RequiresRole);
